module.exports = __webpack_public_path__ + "static/2008-header-e05101e5d7c20e2c309bd02e24d226d1.jpg";